import { Button, Grid, TextField, Container, CircularProgress } from "@mui/material"
import { AddOrEditFormStyles } from "../../styles/AddOrEditFormStyles"
import { GeneralStyles } from "../../styles/GeneralStyles"
import { useState } from "react"
import {notifyInvalidEntity, notifyProductSaved,notifyEdited, notifyError} from "../notifications"
import { saveProvinceModelList, editProvinceModelList} from "../../services/CatalogsService"

const AddOrEditProvidenceForm = ({handleCloseModal, action, productOject, fetchData}) => {
    const [province, setProvince] = useState(productOject ? productOject.province : "")
    const [plant, setPlant] = useState(productOject ? productOject.plant : "")
    const token = localStorage.getItem("site")
    const [savingIsLoading, setSavingIsLoading] = useState(false)


    const clearForm = () => {
        setProvince("")
        setPlant("")
    }


    const saveProvinceModelListAction = async ()=>{
        if(province === "" || plant === "" ) {
            notifyInvalidEntity("Province and Plant are required")
            return
        }
        setSavingIsLoading(true)
        const body = {
            province: province,
            plant: plant,
        }
        try {
            const response = await saveProvinceModelList(token,body)
            if (response.status === 201) {
                notifyProductSaved("Province has been successfully saved")
                setSavingIsLoading(false)                
                clearForm()
            }
        } catch(err) {
            if (err.response.status === 400) {
                notifyError(err.response.data.message)
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const editProvinceModelListAction = async ()=>{
        if(province === "" || plant === "" ) {
            notifyInvalidEntity("Province and Plant are required")
            return
        }
        setSavingIsLoading(true)
        const body = {
            province: province,
            plant: plant,
        }
        try {
            const response = await editProvinceModelList(token,body, productOject.id)
            if (response.status === 200) {
                notifyEdited("Province has been successfully edited")
                setSavingIsLoading(false)                
                handleCloseModal()
                fetchData()
            }
        } catch(err) {
            if (err.response.status === 400) {
                notifyError(err.response.data.message)
            }
        } finally {
            setSavingIsLoading(false)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        switch(action) {
            case "ADD":
                saveProvinceModelListAction()
            break;
            case "EDIT":
                editProvinceModelListAction()
            break;
            default:
                break;
        }
    }

    return (
        <Container maxWidth="sm" sx={AddOrEditFormStyles.form}>
            <form className={AddOrEditFormStyles.form} onSubmit={(e) => handleSubmit(e)}>
                <Grid container>
                    <Grid item xs={6}>
                        <TextField value={province} onChange={(e) => setProvince(e.target.value)}fullWidth id="outlined-basic" label="Province" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle}
                         />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField value={plant} onChange={(e) => setPlant(e.target.value)} fullWidth id="outlined-basic" label="Plant" variant="outlined" sx={AddOrEditFormStyles.textFieldStyle} 
                        />
                    </Grid>
                </Grid>
                <Grid container sx={AddOrEditFormStyles.formActions} >
                    <Button onClick={handleCloseModal} variant="contained" sx={GeneralStyles.btnGrey}>Cancel</Button>
                    <Button type="submit" variant="contained" style={{marginLeft: 10}}>{savingIsLoading ? <CircularProgress size={24} /> : "SAVE"}</Button>
                </Grid>
            </form>
        </Container>
    )
}

export default AddOrEditProvidenceForm